import { ToastProvider as RNNotificationsProvider } from 'react-native-toast-notifications';
import React from 'react';

import { makeStyles } from '@providers/Theme';

type NotificationsProviderProps = {
  children: React.ReactNode;
};

const useStyles = makeStyles(() => ({
  root: {
    backgroundColor: 'transparent',
    padding: 0,
    maxWidth: '100%',
    width: '100%',
  },
}));

export const NotificationsProvider: React.FC<NotificationsProviderProps> = ({
  children,
}) => {
  const styles = useStyles();

  return (
    <RNNotificationsProvider
      placement="top"
      animationType="slide-in"
      animationDuration={250}
      offsetTop={50}
      style={styles.root}
      swipeEnabled={true}>
      {children}
    </RNNotificationsProvider>
  );
};

export function withNotificationsProvider<P extends {}>(
  Component: React.ComponentType<P>,
): React.ComponentType<P> {
  return function ComponentWithNotificationsProvider(props: P) {
    return (
      <NotificationsProvider>
        <Component {...props} />
      </NotificationsProvider>
    );
  } as React.ComponentType<P>;
}
